/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Case_Delivery_FailedInputs */

const vi_station_voice_case_delivery_failed = /** @type {(inputs: Station_Voice_Case_Delivery_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao thất bại`)
};

/**

* @param {Station_Voice_Case_Delivery_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_case_delivery_failed = /** @type {((inputs?: Station_Voice_Case_Delivery_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Case_Delivery_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_case_delivery_failed(inputs)
});